import type { CompanyResponse } from '@shared/schemas';

import api from '@/shared/api/api-client';

import type { TeamMember } from '../domain/company-detail.model';
import type { CompanyDetailQueryGateway } from './company-detail-query';

/**
 * Real implementation over the shared api client; the single place that knows the
 * company-detail endpoints and request shapes (kept 1:1 with the original
 * component). The backend scopes/guards by role, so both detail slices bind this
 * same implementation. `api.get/post` unwrap the `{ success, data }` envelope.
 */
export const httpCompanyDetailQueryGateway: CompanyDetailQueryGateway = {
  loadCompany: (id) => api.get<CompanyResponse>(`/companies/${id}`),

  loadTeam: (id) => api.get<TeamMember[]>(`/companies/${id}/team`),

  enrich: async (id, force) => {
    await api.post(`/companies/${id}/enrich`, { force });
  },
};
